import { Controller } from "@hotwired/stimulus";
import Inputmask from "inputmask";

export default class extends Controller {

  connect() {
    console.log("! Mask on dates activated !");
    const elements = this.element.getElementsByClassName("date_mask");
    Array.from(elements).forEach((element) => {
      const initialValue = element.value;

      // Check if the initial value is in "aaaa-mm-dd" format
      if (/^\d{4}-\d{2}-\d{2}$/.test(initialValue)) {
        // Format the initial value from "aaaa-mm-dd" to "dd/mm/yyyy"
        const formattedValue = initialValue
          .split("-")
          .reverse()
          .join("/")
          .replace(/-/, "/");

        // Set the formatted value back to the element
        element.value = formattedValue;
      }
      Inputmask({
        alias: "datetime",
        inputFormat: "dd/mm/yyyy", // Specify the input format of your initial dates
        placeholder: "__/__/____",
        showMaskOnHover: false,
      }).mask(element);
    });
  }
}
